import React from 'react';

import { PageTitle } from '../../../components';
import { Awards } from '../../../sections';



const AwardPage = () => {

  return (
    <>

      {/* Page title */}
      <PageTitle title={'Awards'} page={'Awards'} />

      {/* Awards Section */}
      <Awards />

    </>
  );
};

export default AwardPage;